export enum MessageType {
    Error,
    Info
}
